/* eslint-disable jsx-a11y/no-autofocus */

import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import Select, { components } from "react-select"

import downIcon from "../../../..//assets/Hub_Icons/downchevron.svg"
import close from "../../../../assets/common/close.svg"
import upIcon from "../../../../assets/Hub_Icons/upchevron.svg"

const Dropdown = ({
    placeholder,
    defaultValue,
    options = [],
    changeHandler,
    className,
    name,
    errorData,
    isMulti,
    disabled,
    menuPlacement, // use for placement of menu of dropdown top bottom etc
    index,
    renderKey,
    dataTestId,
    isRequired = true, // // DON"T MODIFY THIS FLAG, PASS BOOLEAN VALUE FROM COMPONENT LABEL
    isMultiWithCheckbox = false, // DON"T MODIFY THIS FLAG, PASS BOOLEAN VALUE FROM COMPONENT LABEL
    selectedItemLength,
    isValueSelect = false, // DON"T MODIFY THIS FLAG, PASS BOOLEAN VALUE FROM COMPONENT LABEL
    hideOptionsOnChange = false,
    optionsWithHide = [],
    hasSelectBoXChanged,//  THIS CONDITION USED FOR RESET THE DROPDOWN VALUE AFTER SELECTED THE DEPENDEND DROPDOWN
    labelIsRequired = true, //  DON"T MODIFY THIS FLAG, PASS BOOLEAN VALUE FROM COMPONENT LABEL
    isUnselectEnabled = false,
    isCustomErrorMessage = false,
    isMultiValueSelect = false,
    AllSelectLabel,
    isAllOption,
    errorcustomName,
    isSmallInputBox = false
}) => {

    const isValid = errorData && name && errorData[name] ? false : true
    const { t } = useTranslation()
    const [focused, setFocused] = useState(false)

    const initialOptions = useRef(options)
    const [renderOption, setrenderOptions] = useState(initialOptions?.current)

    const { ValueContainer, Placeholder } = components
    const refSelect = useRef(null)
    const allOption = { label: AllSelectLabel, value: "*" }
    const isAllSelected = useRef(false)

    useEffect(() => {
        if (hasSelectBoXChanged) {
            setFocused(false)
        }
    }, [hasSelectBoXChanged])

    useEffect(() => {
        if (options && options.length > 0 && isMulti) {
            const stateOptions =
                options?.filter((option) => {
                    if (initialOptions.current !== undefined) {
                        return !initialOptions?.current.find((newOpt) => {
                            return newOpt === option
                        })
                    }
                }) ?? []
            initialOptions.current = stateOptions
        }
    }, [options])

    useEffect(() => {
        if (refSelect?.current) {
            if (focused) {
                refSelect?.current?.focus()
            } else {
                refSelect?.current?.blur()
            }
        }
    }, [focused])

    useEffect(() => {
        if (defaultValue instanceof Array && defaultValue?.length > 0 && isMulti) {
            const stateOptions =
                initialOptions.current?.filter((option) => {

                    return !defaultValue.find((newOpt) => {
                        return newOpt === option
                    })
                }) ?? []
            const updatedOptions = defaultValue?.concat(stateOptions)
            let uniqueMap = new Map()

            if (updatedOptions?.length > 0) {
                updatedOptions.forEach(item => {
                    let key = `${item?.label}-${item?.value}`
                    if (!uniqueMap.has(key)) {
                        uniqueMap.set(key, item)
                    }
                })
            }


            const finalOptions = Array.from(uniqueMap.values())
            setrenderOptions(finalOptions)
        }
    }, [])

    const CustomValueContainer = ({ children, ...props }) => {
        const PLACEHOLDER_CLASS = `${props.selectProps.isFocused || props.hasValue
            ? "block bg-primary text-xxs w-max"
            : "block bg-primary text-sm "
        } `

        return (
            <ValueContainer { ...props }>
                { labelIsRequired && <Placeholder { ...props } isFocused={ props.isFocused }>
                    <span className="flex h-[2px] relative justify-center items-center bg-[#FFFFFF]">
                        <span className={ PLACEHOLDER_CLASS }>
                            { isRequired && <i className="text-red mr-1">*</i> }
                            { props.selectProps.placeholder }
                        </span>
                    </span>
                </Placeholder> }
                { React.Children.map(children, (child) =>
                    child && child.key !== "placeholder" ? child : null
                ) }
            </ValueContainer>
        )
    }

    function onSelectChange(newOptions) {
        const stateOptions =
            initialOptions.current?.filter((option) => {

                return !newOptions.find((newOpt) => {
                    return newOpt === option
                })
            }) ?? []
        const updatedOptions = newOptions?.concat(stateOptions)

        let uniqueMap = new Map()

        updatedOptions.forEach(item => {
            let key = `${item?.label}-${item?.value}`
            if (!uniqueMap.has(key)) {
                uniqueMap.set(key, item)
            }
        })

        const finalOptions = Array.from(uniqueMap.values())
        //setOptions(finalOptions)
    }

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator { ...props }>
                <img
                    alt="dropdown"
                    src={ props.selectProps.menuIsOpen ? upIcon : downIcon }
                    className=""
                    height={ "16px" }
                    width={ "16px" }
                />
            </components.DropdownIndicator>
        )
    }

    const ClearIndicator = (props) => {
        return (
            <components.ClearIndicator { ...props }>
                <img
                    alt="close"
                    src={ close }
                    className=""
                    height={ "16px" }
                    width={ "16px" }
                />
            </components.ClearIndicator>
        )
    }
    const Input = (props) => {
        if (!props.selectProps.menuIsOpen || props.selectProps.menuIsOpen) {
            return (
                <components.Input autoFocus={ props.selectProps.menuIsOpen } { ...props }>
                    { props.children }
                </components.Input>
            )
        }
        else {
            return (
                <div style={ { border: "1px dotted gray" } }>
                    <components.Input autoFocus={ props.selectProps.menuIsOpen } { ...props }>
                        { props.children }
                    </components.Input>
                </div>
            )
        }
    }
    const CHECK_BOX_SELECTOR = `checkmark absolute h-[18px] w-[18px]  bg-white border rounded-[4px] 
                                    border-primary-50  z-[2]  after:absolute after:hiddent after:content-[''] 
                                    after:w-[6px] after:h-[12px] after:rotate-45  after:border-b-[2px]  
                                    after:border-r-[2px] after:border-white after:left-[5px] after:top-[1px]`
    const Option = (props) => {
        let allSelected = (isAllOption && props?.selectProps?.value?.length === props?.selectProps?.options?.length - 1) ? true : false
        return (
            <>
                <components.Option { ...props }>
                    <div className="flex items-center gap-1" >
                        <div className="relative cursor-pointer  select-none w-[18px] h-[18px] custom-checkbox">
                            <input
                                className="peer w-[18px] h-[18px] absolute opacity-0 z-[1]"
                                type="checkbox"
                                checked={ (props.value === "*" && allSelected) ? props.isSelected : null }
                                onChange={ () => null }
                            />
                            <span
                                className={ ` ${CHECK_BOX_SELECTOR} ${props.isSelected
                                    || (allSelected) ? "after:block !bg-primary-50" : ""}` }
                            ></span>
                        </div>
                        <label className={ `${isSmallInputBox && props?.label?.length > 35 ? "pl-2" : props?.label?.length > 50 ? "pl-2" : ""}` }>{ props.label }</label>
                    </div>
                </components.Option>
            </>
        )
    }

    const MoreSelectedBadge = ({ items, isDisabled = false }) => {
        const title = items?.join(", ")
        return (
            <div
                className={ isDisabled ? "text-primary-50 font-bold ml-3 absolute  right-5" : "text-primary-50 font-bold ml-3 absolute right-0 mt-[5px]" }
                title={ title }
            >
                { `+ ${items.length}` }
            </div>
        )
    }
    const MultiValue = ({ index, getValue, isDisabled, ...props }) => {
        const maxToShow = selectedItemLength || 3
        const overflow = getValue()
            .slice(!isDisabled ? maxToShow : 0)
            .map((x) => x.label)
        if (index < maxToShow) {
            return <components.MultiValue { ...props } />
        }
        if (index === maxToShow) {
            //if (isDisabled)
            // return <components.MultiValue { ...props } /> //If multi dropdown is disabled, all items are shown.
            return <MoreSelectedBadge items={ overflow } isDisabled={ isDisabled } />
        }
        /*} else{
            if (isDisabled)
                return <MoreSelectedBadge items={ overflow } />
            else
                return null
        }*/
    }

    const MultiValueTop = (length, isDisabled) => {
        const maxToShow = selectedItemLength || 3
        const multiTop = "inherit"
        const top = "-36%"

        if (length <= maxToShow) {
            return top
        }
        else {
            if (isDisabled)
                return multiTop
            return top
        }
    }

    const customeStyles = {
        input: (styles) => ({
            ...styles,
            fontSize: "19px",
            lineHeight: "20px",
            padding: "5px 0 5px 0"
        }),
        option: (styles, state) => ({
            ...styles,
            backgroundColor: state.isSelected ? "#E3ECF9" : state.isFocused
                ? "#F8F9FA" : "#fff",
            borderBottom: isMultiWithCheckbox ? "1px solid #CED0D6" : "none",
            padding: 8,
            color: "#000",
            fontSize: 14,
            "&:hover": {
                backgroundColor: state.isSelected ? "#E3ECF9" : "#F8F9FA"
            },
            "&:last-child": {
                borderBottom: "none"
            }
        }),
        singleValue: (styles, state) => ({
            ...styles,
            color: state.isDisabled ? "#34383f" : "#000000"
        }),
        placeholder: (styles, state) => ({
            ...styles,
            color: state.isFocused ? "#34383f" : "#6C6C6C",
            position: "absolute",
            marginTop: (state.selectProps.isFocused || state.hasValue) ? 9 : 10,
            textWrap: "nowrap",
            top:
                state.hasValue ||
                    state.selectProps.inputValue ||
                    state.selectProps.isFocused
                    ? (!state.isMulti) ? "-36%" : MultiValueTop(state?.selectProps?.value?.length, state.isDisabled)
                    : "15%",
            transition: "top 0.2s",
            bottom: (state.isMulti && state.isDisabled) ? "100%" : "inherit",
            padding: "2px",
            display: (state.isMulti && state.isDisabled) ? "flex" : "inherit",
            fontSize:
                state.hasValue ||
                    state.selectProps.inputValue ||
                    state.selectProps.isFocused
                    ? 10
                    : 14
        }),
        indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
        valueContainer: (base) => ({
            ...base,
            paddingLeft: 10,
            paddingTop: 0,
            overflow: "visible"
        }),
        control: (base, state) => ({
            ...base,
            borderRadius: 8,
            fontfamily: "Avenir",
            fontSize: 14,
            height: (state.isMulti && !state.isDisabled) && 38,
            borderColor: state.selectProps.menuIsOpen
                ? "#003DA5"
                : isValid
                    ? "#CED0D6"
                    : "#CE121F",
            boxShadow: null,
            backgroundColor: state.isDisabled
                ? "#F8F9FA"
                : state.selectProps.menuIsOpen
                    ? "#EDF5FF"
                    : "#FFFFFF",
            "&:hover": {
                borderColor: "#003DA5"
            }
        }),
        multiValue: (styles) => ({
            ...styles,
            backgroundColor: "#F3F3F3",
            borderColor: "#CED0D6",
            borderRadius: 10,
            maxWidth: 100
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: "#3438F"
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: "#002466",
            ":hover": {
                backgroundColor: "transparent",
                color: "#002466"
            }
        })
    }

    const getValue = (value, arr, isMulti) => {
        let val = value
        if (val !== undefined) {
            if (!isMulti) {
                if (arr?.length && arr?.find(({ value }) => value === val)) {
                    return arr?.length ? arr.find(({ value }) => value === val) : arr
                } else {
                    return null
                }
            } else {
                return isMultiSelectHelper(val, arr)
            }
        } else {
            return isMulti ? [] : null
        }
    }

    const isMultiSelectHelper = (val, arr) => {
        if (!Array.isArray(val)) {
            let existingValues = val?.split(",")
            existingValues = existingValues?.map(function (el) {
                return el?.trim().toLowerCase()
            })
            return arr?.filter((x) => {
                return existingValues?.includes(x?.label?.toString()?.trim().toLowerCase())
                    || existingValues?.includes(x?.value?.toString()?.trim().toLowerCase())
            })
        } else {
            if (isMultiValueSelect) {
                let existingValues = val?.map(function (el) {
                    if (typeof el === "string") {
                        return el?.trim().toLowerCase()
                    } else {
                        return el
                    }
                })
                return arr?.filter((x) => {
                    if (x?.value && typeof x?.value === "string") {
                        return existingValues?.includes(x?.value?.trim().toLowerCase())
                    } else {
                        return existingValues?.includes(x?.value)
                    }
                })
            }
            return val
        }
    }

    const renderComponent = () => {
        if (isMultiWithCheckbox) {
            return {
                DropdownIndicator,
                ClearIndicator,
                ValueContainer: CustomValueContainer,
                Option,
                Input,
                MultiValue
            }
        } else {
            return {
                DropdownIndicator,
                ValueContainer: CustomValueContainer,
                Input
            }
        }
    }

    const onDropDownBlur = () => {

        setTimeout(() => {
            if (defaultValue instanceof Array && defaultValue?.length > 0 && isMulti) {
                const stateOptions =
                    initialOptions.current?.filter((option) => {

                        return !defaultValue.find((newOpt) => {
                            return newOpt === option
                        })
                    }) ?? []
                const updatedDefaultValue = isMultiValueSelect ? stateOptions?.filter(item => defaultValue.includes(item?.value)) : defaultValue
                const updatedOptions = updatedDefaultValue?.concat(stateOptions)
                let uniqueMap = new Map()
                updatedOptions?.forEach(item => {
                    let key = `${item?.label}-${item?.value}`
                    if (!uniqueMap.has(key)) {
                        uniqueMap.set(key, item)
                    }
                })
                const finalOptions = Array.from(uniqueMap.values())
                setrenderOptions(finalOptions)
            }
        }, 500)
    }
    return (
        <>
            <Select
                id={ name }
                ref={ refSelect }
                className={ className }
                key={ renderKey }
                classNamePrefix="select"
                components={ { ...renderComponent() } }
                styles={ customeStyles }
                placeholder={ placeholder }
                options={ (options?.length > 0 && isAllOption) ? [allOption, ...options] : options }
                { ...(isValueSelect
                    ? {
                        value: !hasSelectBoXChanged ? getValue(defaultValue, hideOptionsOnChange
                            ? optionsWithHide : options, isMulti) : ""
                    }
                    : {
                        defaultValue: getValue(defaultValue, hideOptionsOnChange
                            ? optionsWithHide : options, isMulti)
                    }) }
                getOptionValue={ (opt) => opt.label }
                getOptionLabel={ (opt) => `${opt.label}` }
                name={ name }
                isMulti={ isMulti }
                isClearable={ isUnselectEnabled }
                onFocus={ () => {
                    setFocused(true)
                }
                }
                openMenuOnClick={ true }
                onBlur={ () => {
                    setFocused(false)
                    onDropDownBlur()
                } }
                closeMenuOnSelect={ isMulti && isMultiWithCheckbox ? false : true }
                hideSelectedOptions={ false } // Hide Selected Option
                isFocused={ focused }
                isDisabled={ disabled || false }
                onChange={ (selectedValue) => {
                    if (
                        isMulti &&
                        selectedValue.length &&
                        selectedValue.find((option) => option.value === "*")
                    ) {
                        if (isAllSelected.current === true) {
                            changeHandler([], name, index)
                            onSelectChange([])
                            isAllSelected.current = false
                        } else {
                            changeHandler(options, name, index)
                            onSelectChange(options)
                            isAllSelected.current = true
                        }
                    } else if (isMulti) {
                        if (selectedValue.length > 0) {
                            changeHandler(selectedValue, name, index)
                            onSelectChange(selectedValue)
                            isAllSelected.current = selectedValue.length === options.length
                        } else {
                            changeHandler([], name)
                            onSelectChange([])
                            isAllSelected.current = false
                        }
                    } else {
                        changeHandler(selectedValue, name, index)
                    }
                    //set focus after selecting the dropdown value
                    /*setTimeout(() =>{
                        if(refSelect?.current){
                            refSelect?.current?.focus()
                        }
                    },30)*/
                } }
                data-testid={ dataTestId }
                menuPlacement={ menuPlacement }
                isSearchable={ true }
                aria-labelledby={ name }
            />
            { errorData && name && errorData[name] && (
                <span className="text-red text-xs font-normal font-['Avenir'] leading-[14px] pt-1">
                    { errorcustomName ? t(`errorMessage.${errorcustomName}.${name}`) : isCustomErrorMessage ? errorData[name] : t(`errorMessage.${name}`) }
                </span>
            ) }
        </>
    )
}

Dropdown.propTypes = {
    changeHandler: PropTypes.func,
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    //errorData: PropTypes.object,
    isMulti: PropTypes.bool,
    name: PropTypes.string,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string, // Add this line
    disabled: PropTypes.bool,
    index: PropTypes.number,
    isRequired: PropTypes.bool,
    isMultiWithCheckbox: PropTypes.bool,
    selectedItemLength: PropTypes.number,
    hasSelectBoXChanged: PropTypes.bool,
    isValueSelect: PropTypes.bool,
    children: PropTypes.node, // Add this line
    isSearchable: PropTypes.bool // Add this line
}

export default React.memo(Dropdown)
